import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const EnrollmentReportRedux = createActions(
  {
    EnrollmentReportRequest: ['start_date', 'end_date'],
    EnrollmentReportSuccess: ['data', 'fileName'],
    EnrollmentReportError: ['error'],
    CentersEnrollmentReportRequest: ['start_date', 'end_date', 'centerId'],
    CentersEnrollmentReportSuccess: ['data', 'fileName'],
    CentersEnrollmentReportError: ['error'],
  },
  {
    prefix: 'ENROLLMENTREPORT_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = EnrollmentReportRedux
export const EnrollmentReportTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

/* ------------- Reducers ------------- */

const EnrollmentReportRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const EnrollmentReportSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const EnrollmentReportError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

const CentersEnrollmentReportRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const CentersEnrollmentReportSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const CentersEnrollmentReportError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.EnrollmentReportRequest]: EnrollmentReportRequest,
    [Types.EnrollmentReportSuccess]: EnrollmentReportSuccess,
    [Types.EnrollmentReportError]: EnrollmentReportError,
    [Types.CentersEnrollmentReportRequest]: CentersEnrollmentReportRequest,
    [Types.CentersEnrollmentReportSuccess]: CentersEnrollmentReportSuccess,
    [Types.CentersEnrollmentReportError]: CentersEnrollmentReportError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/EnrollmentReportRedux.js